<template>
  <b-form-group :id="id">
    <b-form-radio-group
      buttons
      stacked
      :options="options"
      button-variant="outline-secondary"
      v-model="selected"
      @change="optionSelected"
      class="w-100"
    />
  </b-form-group>
</template>

<script>
export default {
  name: "OptionsPrompt",
  props: {
    id: String,
    answers: Array,
    currentOption: Number,
  },
  data() {
    return {
      selected: this.currentOption,
    };
  },
  methods: {
    optionSelected(options) {
      this.$emit("optionSelected", { answers: options });
    },
  },
  computed: {
    options() {
      return this.answers.map((answer) => {
        return { text: answer.text, value: answer.id };
      });
    },
  },
};
</script>

<style scoped lang="scss">
::v-deep .btn-group-vertical {
  .btn-outline-secondary {
    border-radius: 4px !important;
    padding: 16px;
    margin-bottom: 16px;
  }
}
</style>
